document.addEventListener('DOMContentLoaded', function () {
    function attachLabelUploadHandlers() {
        document.querySelectorAll('input[type="file"][data-label-upload]').forEach(input => {
            if (input.dataset.handlerAttached) return;
            input.dataset.handlerAttached = "1";
            const labelId = input.dataset.labelId;
            const btn = document.getElementById('label-upload-btn-' + labelId);
            const txt = document.getElementById('label-upload-text-' + labelId);

            input.addEventListener('change', function (e) {
                const file = e.target.files && e.target.files[0];
                console.log('label upload change for id:', labelId, file);
                if (!file) return;
                if (btn) btn.disabled = true;
                if (txt) txt.textContent = 'Uploading...';

                // Fallback: POST the file to a regular route
                const formData = new FormData();
                formData.append('file', file);
                fetch('/labels/' + labelId + '/upload', {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: formData
                }).then(response => response.json()).then(data => {
                    console.log('Fallback upload response', data);
                    if (btn) btn.disabled = false;
                    if (txt) txt.textContent = 'Upload';
                }).catch(err => {
                    console.error('Fallback upload error', err);
                    if (btn) btn.disabled = false;
                    if (txt) txt.textContent = 'Upload';
                });
            });
        });
    }

    // Attach on page load
    attachLabelUploadHandlers();

    // Attach after every Livewire update
    document.addEventListener('livewire:load', function () {
        window.Livewire.hook('message.processed', attachLabelUploadHandlers);
    });
});
